import { useState } from 'react';

export const ORDER_OPTIONS = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
});

export const useSortableTable = (defaultSortBy) => {
  const [sortBy, setSortBy] = useState(defaultSortBy);
  const [sortOrder, setSortOrder] = useState(ORDER_OPTIONS.ASC);

  const iconType = sortOrder === ORDER_OPTIONS.ASC ? 'caret_up' : 'caret_down';

  const handleColumnClick = (column) => {
    if (sortBy === column) {
      setSortOrder((prev) =>
        prev === ORDER_OPTIONS.ASC ? ORDER_OPTIONS.DESC : ORDER_OPTIONS.ASC
      );
    } else {
      setSortBy(column);
      setSortOrder(ORDER_OPTIONS.ASC);
    }
  };

  return { sortBy, sortOrder, iconType, handleColumnClick };
};
